import IDataGridService from "./IDataGridService";
import { injectable } from "inversify";
import IDataGridSettings from "./IDataGridSettings";
import { getPaginationDefaults } from "features/shared/helpers/queryParams";
import { containsKey } from "features/shared/helpers/objects";

@injectable()
export default class DataGridService implements IDataGridService {
  computeQueryParams(dataGridSettings: IDataGridSettings): string {
    let computedUrlSearchParams = "";

    const pagination: string = dataGridSettings.paginationUrlSearchParams ?? "";
    const filter: string = dataGridSettings.filtrUrlSearchParams ?? "";
    const sorting: string = dataGridSettings.sortingUrlSearchParams ?? "";

    if (pagination) {
      computedUrlSearchParams = pagination;
    }
    if (filter) {
      computedUrlSearchParams += computedUrlSearchParams.length > 0 ? `&${filter}` : filter;
    }
    if (sorting) {
      computedUrlSearchParams += computedUrlSearchParams.length > 0 ? `&${sorting}` : sorting;
    }

    return computedUrlSearchParams;
  }

  getSettings(
    filterUrlParams: string | undefined,
    paginationUrlParams: string | undefined,
    sortingUrlParams: string | undefined,
    pageSize: number | undefined
  ): IDataGridSettings {
    pageSize = pageSize ?? 10;

    let settings: IDataGridSettings = {
      computedUrlSearchParams: "",
      defaultPageSize: pageSize,
      filtrUrlSearchParams: filterUrlParams ?? undefined,
      paginationUrlSearchParams: paginationUrlParams ?? getPaginationDefaults(pageSize, 1).toString(),
      sortingUrlSearchParams: sortingUrlParams ?? undefined
    };

    settings.computedUrlSearchParams = this.computeQueryParams(settings);

    return settings;
  }

  getEmptySettings(pageSize?: number): IDataGridSettings {
    return {
      computedUrlSearchParams: "",
      defaultPageSize: pageSize ?? 10,
      filtrUrlSearchParams: "",
      paginationUrlSearchParams: "",
      sortingUrlSearchParams: "",
    };
  }

  // getNewSettings(originalSettings: IDataGridSettings, propName: string, propNewValue: string): IDataGridService {
  //   let newSettings: any = {...originalSettings};
    
  //   if (containsKey(newSettings, propName)) {
  //     newSettings[propName] = propNewValue;
  //   }

  //   return newSettings;
  // }
}
